import React from "react";
// ANT DESIGN COMPONENTS
import { Table, Select } from "antd";
// INTERFACES
import { FormularyHeaderInputLiftPositionInterface } from "../../../interfaces/Global.interface";
import { LiftInterface } from "../../../interfaces/Lift.interface";
import { formatUuidT } from "../../../flatbuffers/display";

export default function FormularyHeaderInputLiftPosition({
  columnName,
  inputPlaceholder,
  formAction,
  value,
  onChangeFormValue,
  variableName,
  itemId,
  values,
  onClickCellName = () => {},
  enabledCellClick = false,
  bankId = "",
  disableCreateRow = false,
}: FormularyHeaderInputLiftPositionInterface) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const { Column, ColumnGroup } = Table;
  const { Option } = Select;

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // CUSTOM HOOKS *********************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <ColumnGroup title={columnName}>
      <Column
        className="generalStyles__hoverCursor"
        onCell={(record: any) => ({
          onClick: () => {
            if (enabledCellClick && (disableCreateRow || formAction === "create")) {
              onClickCellName(record);
            }
          },
        })}
        title={
          disableCreateRow ? (
            columnName
          ) : (
            <Select
              optionFilterProp="children"
              allowClear={false}
              size="small"
              value={
                formAction === "create"
                  ? `${
                      bankId === "" ? "Select a bank" : `${value === 0 ? "Select position" : value}`
                    }`
                  : null
              }
              disabled={formAction === "edit" || values.length === 0}
              className="generalStyles__width100"
              placeholder={inputPlaceholder}
              onChange={(e: string | number) => {
                onChangeFormValue(e, variableName);
              }}
            >
              {values.map((item: any) => (
                <Option
                  key={formatUuidT(item.id)}
                  value={formatUuidT(item.id)}
                  disabled={item.reserved}
                >
                  {item.name}
                </Option>
              ))}
            </Select>
          )
        }
        dataIndex={variableName}
        key={variableName}
        render={(text, record: LiftInterface) => (
          <div>
            {formAction === "edit" && String(record.id) === itemId ? (
              <Select
                optionFilterProp="children"
                allowClear={false}
                size="small"
                value={value}
                className="generalStyles__width100"
                placeholder={inputPlaceholder}
                onChange={(e: string | number) => {
                  onChangeFormValue(e, variableName);
                }}
                disabled
              >
                {values.map((item: any) => (
                  <Option
                    key={formatUuidT(item.id)}
                    value={formatUuidT(item.id)}
                    disabled={item.reserved}
                  >
                    {item.name}
                  </Option>
                ))}
              </Select>
            ) : (
              <div>{record.position}</div>
            )}
          </div>
        )}
      />
    </ColumnGroup>
  );
}
